import {CloseOutlined} from '@ant-design/icons';
import {Drawer, Flex, Button} from 'antd';
import {ColumnsType} from 'antd/es/table';
import React from 'react';

import {defaultCol} from '../../components/Table/Interface/ITable';
import {drawerZIndex} from '../../constants/Common';

import MySvgComponent from './../../components/DrawerForm/Utils/StepIconDrawer';

interface ChildComponentProps {
  columns?: defaultCol & ColumnsType<any>[0];
  dataSource?: any;
  props?: any;
}

interface DrawerProp {
  onCancel: () => void;
  open: boolean;
  stepTitle: string;
  ChildComponent: React.ReactElement;
}

const ReportStudioDrawer: React.FC<DrawerProp> = ({
  onCancel,
  open,
  stepTitle,
  ChildComponent
}) => {
  return (
    <Drawer
      placement="right"
      size="large"
      onClose={onCancel}
      destroyOnClose={true}
      zIndex={drawerZIndex}
      className="reportStudioDrawer"
      footer={
        <Flex className="drawerButtonContainer">
          <div>
            <Button onClick={onCancel} className="drawerButton drawerCancel">
              Cancel
              <CloseOutlined />
            </Button>
          </div>
        </Flex>
      }
      open={open}
      closeIcon={false}
      title={
        <Flex
          vertical={false}
          gap={8}
          align="center"
          style={{
            height: '112px',
            marginLeft: '48px',
            backgroundColor: '#ffffff'
          }}
        >
          <Flex className="iconCircle">
            <MySvgComponent isReportStudio={true} />
          </Flex>

          <Flex>{stepTitle}</Flex>
        </Flex>
      }
      style={{background: '#F3F4F8'}}
    >
      <Flex
        style={{
          height: '100%',
          backgroundColor: '#ffffff',
          borderRadius: '8px'
        }}
      >
        <div
          style={{margin: '36px 24px', maxHeight: '100%', overflowY: 'scroll'}}
        >
          {React.cloneElement(
            ChildComponent as React.ReactElement<ChildComponentProps>,
            {
              ...ChildComponent.props
            }
          )}
        </div>
      </Flex>
    </Drawer>
  );
};

export default ReportStudioDrawer;
